<div class="dialog">
  <div class="title flex-space-between">
    {{ "bookmarksDialog.title" | translate }}
    <evc-svg-icon id="eye-icon" (click)="close()" size="md" icon="xmark"></evc-svg-icon>
  </div>

  <div>
    <div fxFlex>
      <div class="title">
        {{ "bookmarksDialog.saveTitle" | translate }}
      </div>

      <form [formGroup]="bookmarkForm">
        <input
          data-testid="save-input"
          type="text"
          class="input"
          formControlName="newBookmarkName"
          placeholder="{{ 'bookmarksDialog.newBookmarkPlaceholder' | translate }}"
        />
      </form>
      <div *ngIf="newBookmarkName.hasError('duplicateName')" class="error-message">
        {{ "bookmarksDialog.duplicateNameError" | translate }}
      </div>
      <evc-nav-button
        [disabled]="bookmarkForm.invalid"
        type="primary"
        id="save-button"
        variant="semi"
        leftIcon="floppy-disk"
        (click)="saveBookmark()"
      >
        {{ "bookmarksDialog.saveButton" | translate }}
      </evc-nav-button>
    </div>

    <div class="dividing-line"></div>

    <div fxFlex class="load">
      <div class="title">
        {{ "bookmarksDialog.load" | translate }}
      </div>
      <div class="search-area">
        <input
          data-testid="filter-input"
          class="form-control"
          type="text"
          [(ngModel)]="searchText"
          (input)="updateFilter()"
          placeholder="{{ 'bookmarksDialog.searchPlaceholder' | translate }}"
        />
        <evc-svg-icon size="sm" icon="magnifying-glass"></evc-svg-icon>
      </div>
      <table data-testid="bookmarks-table">
        <tr
          *ngFor="let bookmark of filteredBookmarks"
          (click)="selectBookmark(bookmark)"
          (mouseleave)="hoverBookmark(null)"
          (dblclick)="openBookmark(bookmark)"
          (mouseenter)="hoverBookmark(bookmark)"
        >
          <div class="row" [ngClass]="{ highlight: highlightRow(bookmark) }">
            <td class="bookmark-name">{{ bookmark.bookmarkName }}</td>
            <td *ngIf="highlightRow(bookmark)" data-testid="delete-icon" (click)="deleteBookmark(bookmark)" class="delete-bookmark">
              <mat-icon>close</mat-icon>
            </td>
          </div>
        </tr>
      </table>
    </div>
  </div>

  <div>
    <div class="title">
      {{ "bookmarksDialog.share" | translate }}
    </div>
    <div class="share-block">
      <div class="shared-url" data-testid="shared-url">
        {{ sharedUrl }}
      </div>
      <evc-nav-button type="primary" variant="semi" leftIcon="link-simple" (click)="copyBookmark()">
        {{ "bookmarksDialog.copyBookmark" | translate }}
      </evc-nav-button>
    </div>
  </div>
</div>

<!-- hide xs  -->
